import { GlobalVariables } from 'shell-models-lib';
import { environment } from './environment';
import { Environments } from './environment-names';

function getFabricEnvironment(fabricEnv: string | undefined): Environments {
    switch (fabricEnv) {
        case 'Onebox':
        case 'INT':
        case 'TEST':
            return Environments.ppe;
        case 'FF':
        case 'TB':
        case 'TBC':
        case 'PF':
            return Environments.fairfax;
        case 'MC':
            return Environments.mooncake;
        case 'USNat':
            return Environments.adfusnat;
        case 'USSec':
            return Environments.adfussec;
        case 'Bleu':
            return Environments.adfbleu;
        default:
            // Missing or unknown names default to production; Fabric does not support Delos yet.
            return Environments.production;
    }
}

export function getCurrentEnvironment(): Environments {
    return __IS_FABRIC_ADF__ || __IS_FABRIC_DPE__
        ? getFabricEnvironment(GlobalVariables.fabricEnv)
        : environment;
}
